import styled from "styled-components";
import { themeTypes } from "../../styled/Theme";

export const StyledMatchTile = styled.div`
  display: flex;
  align-items: center;

  .mls-c-club__picture {
    margin-top: 4px;
  }

  .--home .mls-c-club__abbreviation {
    width: 74px;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .--away .mls-c-club__abbreviation {
    width: 74px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.--post .--home-loser,
  &.--post .--away-loser {
    color: ${(props) =>
      props.theme.type == themeTypes.light
        ? props.theme.figma.base.color_offblack_50
        : props.theme.figma.base.color_offwhite_50};
  }
`;

export const StyledEmptyScorebug = styled.div`
  width: 60px;
`;
